export const outstanding_transactions_display = {
  outstanding_heading: "Outstanding transactions",
  outstanding_count: "{count} outstanding",
  outstanding_amount: "{amount} unallocated",
  view_outstanding: "View outstanding transactions",
};
